import styled from "styled-components";

export default styled.div<{ pullRight?: boolean, relative?: boolean }>`
  ${props => props.pullRight && `margin-left: auto;`}
  ${props => props?.relative && `position: relative;`}
  
`;
